export function formatBadgeCount(count) {
    const value = Number(count) || 0;
    if (value <= 0) return null;
    return value > 99 ? '99+' : String(value);
}

/** Бейдж чата: реальные сообщения или 1 при ручной пометке. */
export function computeChatBadgeCount(unreadCount, manualUnread) {
    const messages = Number(unreadCount) || 0;
    if (messages > 0) return messages;
    return Number(manualUnread) ? 1 : 0;
}

export function sumBadgeTotals(byUserId) {
    const totals = { tasks: 0, documents: 0, chat: 0 };
    let hasEmptyBankPack = false;

    Object.values(byUserId || {}).forEach((row) => {
        totals.tasks += Number(row?.tasks) || 0;
        totals.documents += Number(row?.documents) || 0;
        totals.chat += Number(row?.chat) || 0;
        if (row?.hasEmptyBankPack) {
            hasEmptyBankPack = true;
        }
    });

    return { totals, hasEmptyBankPack };
}
